import React from "react";
import { Row, Col, Space } from "antd";
import hard1 from "./images/stool/hard-1.png";
import hard2 from "./images/stool/hard-2.png";
import hard3 from "./images/stool/hard-3.png";
import formed from "./images/stool/formed.png";
import loose1 from "./images/stool/loose-1.png";
import loose2 from "./images/stool/loose-2.png";
import watery from "./images/stool/watery.png";

function StoolResults(aiInferences) {
    return (
        <>
            <Row gutter={[16, 16]}>
                <Col span={24} md={12}>
                    <div className="stool-results">
                        {aiInferences?.consistency === "hard" &&
                            aiInferences?.score === 1 && (
                                <Space>
                                    Hard 1
                                    <img src={hard1} alt="" />
                                </Space>
                            )}
                        {aiInferences?.consistency === "hard" &&
                            aiInferences?.score === 2 && (
                                <Space>
                                    Hard 2
                                    <img src={hard2} alt="" />
                                </Space>
                            )}
                        {aiInferences?.consistency === "hard" &&
                            aiInferences?.score === 3 && (
                                <Space>
                                    Hard 3
                                    <img src={hard3} alt="" />
                                </Space>
                            )}
                        {aiInferences?.consistency === "formed" && (
                            <Space>
                                Formed
                                <img src={formed} alt="" />
                            </Space>
                        )}
                        {aiInferences?.consistency === "loose" &&
                            aiInferences?.score === 5 && (
                                <Space>
                                    Loose 1
                                    <img src={loose1} alt="" />
                                </Space>
                            )}
                        {aiInferences?.consistency === "loose" &&
                            aiInferences?.score === 6 && (
                                <Space>
                                    Loose 2
                                    <img src={loose2} alt="" />
                                </Space>
                            )}
                        {aiInferences?.consistency === "watery" && (
                            <Space>
                                Watery
                                <img src={watery} alt="" />
                            </Space>
                        )}

                        <div className="stool-results-text">
                            {aiInferences?.consistency === "hard" && (
                                <>
                                    <p>
                                        Occasional hard stools are common,
                                        especially in formula fed babies or
                                        babies that are introduced to solid
                                        foods. They can be painful when passing,
                                        may cause tiny tears around your baby's
                                        anus, and sometimes may even cause
                                        superficial bleeding. If you are unsure
                                        contact your healthcare professional.
                                    </p>
                                    <p>
                                        Hard stools that persist over days are
                                        generally a concern and a reason to
                                        contact your healthcare professional for
                                        advice. Do not give any medication, oral
                                        supplements, or other remedies to your
                                        baby unless advised by your healthcare
                                        professional.
                                    </p>
                                </>
                            )}
                            {aiInferences?.consistency === "formed" && (
                                <p>
                                    Your baby's stools will most frequently be
                                    soft to formed. Stool consistency and color
                                    change over time. This is normal.
                                </p>
                            )}
                            {aiInferences?.consistency === "loose" && (
                                <p>
                                    A breastfed baby's normal stool is most of
                                    the time loose and at times grainy or seedy.
                                    A formula fed baby's normal stool will be
                                    thicker. If the stool is frothy or mucousy
                                    you should mention it to your healthcare
                                    professional. Acute changes in your baby's
                                    stool frequency, consistency, and color
                                    require specific attention. This is
                                    especially the case if there have been no
                                    changes in your baby's diet. If you are in
                                    doubt consult always a healthcare
                                    professional.
                                </p>
                            )}
                            {aiInferences?.consistency === "watery" && (
                                <p>
                                    Watery stools may occur sporadically in
                                    otherwise healthy infants. Breastfed infants
                                    may have very soft or even watery stools. If
                                    your baby passes three or more watery stools
                                    within 24 hours, or has watery stools over a
                                    longer period of time, this could be
                                    diarrhea. Diarrhea causes rapid loss of
                                    water. The younger the baby and the more
                                    frequent the watery stools, the bigger the
                                    concern. Thus contact your health healthcare
                                    professional immediately. Do not give your
                                    baby any anti-diarrhea medication, oral
                                    supplements, or other remedies unless
                                    advised by your healthcare professional.
                                </p>
                            )}
                        </div>
                    </div>
                </Col>
                <Col span={24} md={12}>
                    <div className="stool-results">
                        {aiInferences?.color === "Yellow" && (
                            <Space align="center">
                                Yellow
                                <div
                                    className="stool-color"
                                    style={{ backgroundColor: "#E4D74D" }}
                                ></div>
                            </Space>
                        )}
                        {aiInferences?.color === "Orange" && (
                            <Space align="center">
                                Orange
                                <div
                                    className="stool-color"
                                    style={{ backgroundColor: "#E47646" }}
                                ></div>
                            </Space>
                        )}
                        {aiInferences?.color === "Green" && (
                            <Space align="center">
                                Green
                                <div
                                    className="stool-color"
                                    style={{ backgroundColor: "#306F27" }}
                                ></div>
                            </Space>
                        )}
                        {aiInferences?.color === "Brown" && (
                            <Space align="center">
                                Brown
                                <div
                                    className="stool-color"
                                    style={{ backgroundColor: "#795F1F" }}
                                ></div>
                            </Space>
                        )}
                        {aiInferences?.color === "Black" && (
                            <Space align="center">
                                Black
                                <div
                                    className="stool-color"
                                    style={{ backgroundColor: "#1C1C1D" }}
                                ></div>
                            </Space>
                        )}
                        {aiInferences?.color === "Pale/Clay" && (
                            <Space align="center">
                                Pale/Clay
                                <div
                                    className="stool-color"
                                    style={{ backgroundColor: "#A4A4A4" }}
                                ></div>
                            </Space>
                        )}
                        {aiInferences?.color === "Red" && (
                            <Space align="center">
                                Red
                                <div
                                    className="stool-color"
                                    style={{ backgroundColor: "#921C16" }}
                                ></div>
                            </Space>
                        )}

                        <div className="stool-results-text">
                            {aiInferences?.color === "Yellow" && (
                                <p>
                                    Formula fed babies and those who have
                                    started eating solid foods will have usually
                                    yellow, dark orange, or brown stools. Breast
                                    feed babies have frequently mustard colored
                                    stools. However, dark orange or brown stools
                                    are also common.
                                </p>
                            )}
                            {aiInferences?.color === "Orange" && (
                                <p>
                                    Formula fed babies and those who have
                                    started eating solid foods will have usually
                                    yellow, dark orange, or brown stools. Breast
                                    feed babies have frequently mustard colored
                                    stools. However, dark orange or brown stools
                                    are also common.
                                </p>
                            )}
                            {aiInferences?.color === "Green" && (
                                <p>
                                    Green stools occur frequently in babies that
                                    receive some kind of iron-supplement or iron
                                    fortified formula. Dark green stools are
                                    generally common. In breast fed babies foamy
                                    green stools indicate sometimes an imbalance
                                    of fore- and hind-milk feeding. Make sure
                                    that one breast is emptied completely before
                                    switching to the other.
                                </p>
                            )}
                            {aiInferences?.color === "Brown" && (
                                <p>
                                    Formula fed babies and those who have
                                    started eating solid foods will have usually
                                    yellow, dark orange, or brown stools. Breast
                                    feed babies have frequently mustard colored
                                    stools. However, dark orange or brown stools
                                    are also common.
                                </p>
                            )}
                            {aiInferences?.color === "Black" && (
                                <>
                                    <p>
                                        A newborn's first stool is called
                                        meconium. It is usually a thick, black
                                        or dark green, sometimes tarry like
                                        substance, and perfectly normal. The
                                        color and consistency of the stools will
                                        change soon as your baby is drinking
                                        more.
                                    </p>
                                    <p>
                                        Black stools may sometimes occur due to
                                        iron supplementation. However, if you
                                        are not sure contact your healthcare
                                        professional.
                                    </p>
                                    <p>
                                        Contact your healthcare professional
                                        also if: your newborn has not passed
                                        meconium within 24 hours after birth,
                                        your newborn continues to have black
                                        stools for more than two to three days
                                        after birth or your baby's stools turn
                                        black or tarry like at any later point
                                        after having passed meconium.
                                    </p>
                                </>
                            )}
                            {aiInferences?.color === "Pale/Clay" && (
                                <p>
                                    If you see that your baby has a white, pale
                                    yellow or chalky grey stool, you must
                                    contact your healthcare professional
                                    immediately. This may indicate blockage of
                                    the liver. The most common cause for this is
                                    called biliary atresia and early diagnosis
                                    is critical for proper treatment.
                                </p>
                            )}
                            {aiInferences?.color === "Red" && (
                                <>
                                    <p>
                                        Once your baby starts eating solid or
                                        pureed foods, the color of stools will
                                        change. For example, beet root may cause
                                        stools to turn red. If you are
                                        uncertain, it is best to consult your
                                        healthcare professional.
                                    </p>
                                    <p>
                                        If there is blood in the diaper or
                                        stools seems to have streaks or patches
                                        of blood, it is important that you
                                        contact your healthcare professional
                                        immediately.
                                    </p>
                                </>
                            )}
                        </div>
                    </div>
                </Col>
            </Row>
        </>
    );
}

export default StoolResults;
